import React from "react";

const TYPE_TITLES = {
  LOYALTY_POINT_ADDED: "Points earned",
};

const PLATFORM_LABELS = {
  LINKEDIN: "LinkedIn",
  FACEBOOK: "Facebook",
  INSTAGRAM: "Instagram",
  TWITTER: "Twitter",
  YOUTUBE: "YouTube",
};

const normalizePlatformLabels = (message = "") =>
  Object.entries(PLATFORM_LABELS).reduce(
    (nextMessage, [rawLabel, displayLabel]) =>
      nextMessage.replace(new RegExp(`\\b${rawLabel}\\b`, "g"), displayLabel),
    message
  );

const formatLoyaltyPointMessage = (message = "") => {
  let formattedMessage = normalizePlatformLabels(message);

  formattedMessage = formattedMessage.replace(
    /^Loyalty points added for /,
    "You earned points for "
  );
  formattedMessage = formattedMessage.replace(/sharing in /gi, "sharing on ");
  formattedMessage = formattedMessage.replace(/posting in /gi, "posting on ");
  formattedMessage = formattedMessage.replace(/engaging in /gi, "engaging on ");
  formattedMessage = formattedMessage.replace(/visiting featured post in /gi, "visiting featured post on ");
  formattedMessage = formattedMessage.replace(/\bon MANUAL\b/gi, "on Featured Post");
  formattedMessage = formattedMessage.replace(/\bin MANUAL\b/gi, "in Featured Post");
  formattedMessage = formattedMessage.replace(
    /Added points:\s*(\d+)/i,
    "+$1 points"
  );

  return formattedMessage || "You have a new update.";
};

export const formatNotification = (notification = {}) => {
  const { type, data } = notification;

  if (type === "LOYALTY_POINT_ADDED") {
    return {
      title: TYPE_TITLES[type],
      message: formatLoyaltyPointMessage(data),
    };
  }

  return {
    title: TYPE_TITLES[type] || "Notification",
    message: normalizePlatformLabels(data) || "You have a new update.",
  };
};

export const renderFormattedMessage = (message = "") => {
  if (!message) return null;

  const pointsRegex = /(\+\d+\s*points?|\+\d+\s*pts?)/gi;
  const parts = message.split(pointsRegex);

  if (parts.length <= 1) {
    return message;
  }

  return (
    <>
      {parts.map((part, i) => {
        if (/^(\+\d+\s*points?|\+\d+\s*pts?)$/i.test(part.trim())) {
          return (
            <span key={i} style={{ color: "#2E7D32", fontWeight: 400 }}>
              {part}
            </span>
          );
        }
        return part;
      })}
    </>
  );
};
